


        <div class="container" style="margin-top: 8%; padding: 0px 28px;">

          <form [formGroup]="productForm" #f="ngForm" (ngSubmit)="done()" method="post" autocomplete="off">
            <div class="row" style="margin-bottom:5px;">
              <div class="col-sm-4" style="margin-top: -25px;">
                <div class="row" style="margin-left: -8px;">
                  <ng-container >
                    <div class="col-sm-4">
                      <input type="text" formControlName="prod_code" class="form-control" placeholder="" disabled
                        style="text-align: center;">
                    </div>
                    <div class="col-sm-4">
                      <input type="text" formControlName='status_desc' class="form-control" placeholder=""
                        disabled style="text-align: center;">
                    </div>
                    <div class="col-sm-4">
                      <input type="text" formControlName='new' class="form-control" placeholder="" disabled
                        style="text-align: center;">
                    </div>
                  </ng-container>
                </div>
              </div>
              <ng-container>
                <div class="col-sm-4">
                  <h4 style="font-size: 15px;text-align: center;color: #1a9950;margin-top: -20px;font-weight: 600">
                    Product Master - Farm</h4>
                </div>
              </ng-container>
              <div class="col-sm-4" style="margin-top: -25px;">
                <div style="float:right;">
                  <button mat-icon-button aria-label="close dialog" mat-dialog-close>
                    <i class="fa fa-times" style="font-size:13px;float:right; cursor: pointer;"></i>
                  </button>
                </div>
              </div>
        
            </div>
                <div class="row">
                  
                    <div id="scrollv" class="col-sm-12 border1">
                      <div class="row" style="margin-top:10px;margin-bottom: 13px;">
                        <div class="col-sm-2"  *ngFor="let f of pgType">
                          <div class="form-check-inline" >
                            <label class="form-check-label">
                              <input type="radio" [value]="f.master_code" class="form-check-input" name="optradio" 
                              formControlName="farm_prod_flag" (click)="onselectFarm(f)" [ngClass]="{'ml-98' : f.master_code == 'N'}" >
                              {{f.master_desc}}
                            </label>
                          </div>
                        </div>

                        <div class="col-sm-9"></div>
                      </div>
                        <div class="row">
                            <div class="col-sm-9">
                                <div class="row">
                                  <ng-container *ngFor="let ls of formData">
                                    <div class="col-sm-8 tc" *ngIf="ls.ctrl_id == 'prod_desc'">
                                       <label for="fponame">{{ls.label_desc}}<span class="mandatory">*</span></label>
                                       <div class="input-group mb-3">
                                        <input [readonly]="mode == 'View'" type="text" style="width: 100%;" class="form-control" formControlName={{ls.ctrl_id}}>
                                      </div>
                                    </div>
                                    <div class="col-sm-4 tc" *ngIf="ls.ctrl_id == 'prod_type_code'">
                                       <label for="fponame">{{ls.label_desc}} <span class="mandatory">*</span></label>
                                       <div class="input-group mb-3">
                                        <select *ngIf="mode !== 'View'" class="form-control" placeholder=""  formControlName={{ls.ctrl_id}} style="height:32px;"
                                        (change)='onSelectProdType($event)'>
                                        <option value="" disabled selected>Select</option>
                                        <option *ngFor="let pt of prodTypeList" [value]="pt.master_code"> {{pt.master_desc}} </option>
                                      </select>
                                        <input *ngIf="mode == 'View'" readonly type="text" style="width: 100%;" class="form-control" formControlName="prod_type_desc">
                                      </div>
                                    </div>
                                  </ng-container>
                                </div>
                                <div class="row">
                                  <ng-container *ngFor="let ls of formData">
                                    <div class="col-sm-4 tc" *ngIf="ls.ctrl_id == 'category_code'">
                                       <label for="fponame">{{ls.label_desc}} <span class="mandatory">*</span></label>
                                       <div class="input-group mb-3">
                                        <select *ngIf="mode !== 'View'" class="form-control" placeholder="" formControlName={{ls.ctrl_id}} style="height:32px;"
                                        (change)='onSelectCategory($event)'>
                                        <option value="" disabled selected>Select</option>
                                        <option *ngFor="let ct of categoryList" [value]="ct.master_code"> {{ct.master_desc}} </option>
                                      </select>
                                        <input *ngIf="mode == 'View'" readonly type="text" style="width: 100%;" class="form-control" formControlName="category_desc">
                                      </div>
                                    </div>
                                    <div class="col-sm-4 tc" *ngIf="ls.ctrl_id == 'subcategory_code'">
                                       <label for="fponame">{{ls.label_desc}} <span class="mandatory">*</span></label>
                                       <select *ngIf="mode !== 'View'" class="form-control" placeholder="" formControlName={{ls.ctrl_id}} style="height:32px;"
                                       (change)='onSelectSubCategory($event)'>
                                       <option value="" disabled selected>Select</option>
                                       <option *ngFor="let sct of subCategory" [value]="sct.master_code"> {{sct.master_desc}} </option>
                                     </select>
                                        <input *ngIf="mode == 'View'" readonly type="text" style="width: 100%;" class="form-control" formControlName="subcategory_desc">
                                    </div>
                                    <div class="col-sm-4 tc"  *ngIf="ls.ctrl_id == 'uom_code'">
                                       <label for="fponame">{{ls.label_desc}} <span class="mandatory">*</span></label>
                                       <div class="input-group mb-3">
                                        <select *ngIf="mode !== 'View'" class="form-control" placeholder="" formControlName={{ls.ctrl_id}} style="height:32px;"
                                        (change)='onSelectUOM($event)'>
                                        <option value="" disabled selected>Select</option>
                                        <option *ngFor="let u of uomList" [value]="u.master_code"> {{u.master_desc}} </option>
                                      </select>
                                        <input *ngIf="mode == 'View'" readonly type="text" style="width: 100%;" class="form-control" formControlName="uom_desc">
                                      </div>
                                    </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="col-sm-2">
                            <div class="row" style="margin-top:20px;">
                                <div class="col-sm-12" >
                                    <label for="image">
                                      <input type="file" (change)="fileChangeEvent($event)" name="image" id="image" style="display:none; cursor: pointer;"/>
                                      <img style="cursor: pointer;" [ngClass]="{'prod_img' : imageFile}" [src]="imageFile ? imageFile : 'assets/images/producticon.jpg'"/>
                                    </label>
                                    <div *ngIf="isImageSaved" style="text-align: center; margin-top: 17px;">
                                    <a  class="btn btn-danger" (click)="removeImage()">Remove</a>
                                  </div>
                                </div>
                            </div>
                        </div>
                        </div>

                         <div class="container" style="margin-top:20px;">
                          <ul class="nav nav-pills" role="tablist" style="width:105%;">
                            <ng-container *ngFor="let ls of formData">
                              <li class="nav-item" *ngIf="ls.ctrl_id == 'Language'">
                                <a class="nav-link active" data-toggle="pill" href="#language">{{ls.label_desc | titlecase}}</a>
                              </li>
                              <li class="nav-item" *ngIf="ls.ctrl_id == 'price'">
                                <a class="nav-link" data-toggle="pill" href="#price">{{ls.label_desc | titlecase}}</a>
                              </li>
                              <li class="nav-item"  *ngIf="ls.ctrl_id == 'quality'">
                                <a class="nav-link " data-toggle="pill" href="#quality">{{ls.label_desc | titlecase}}</a>
                              </li>
                            </ng-container>
                          </ul>
                
                          <div class="tab-content" style="margin-left: -28px; margin-right: -25px; margin-top: 7px;">
                            <div id="language" class="container tab-pane active" style="padding:0px;">
                              <kendo-grid [data]="gridata"
                              [sortable]="{
                               allowUnsort: allowUnsort,
                               mode: multiple ? 'multiple' : 'single'
                             }"
                             [filter]="state.filter"
                             filterable="menu"
                             (sortChange)="sortChange($event)"
                             (dataStateChange)="dataStateChange($event)"
                             [columnMenu]="{ filter: true }"
                             [skip]="skip"
                             [pageSize]="pageSize"
                             [pageable]="true"
                             [resizable]="true"
                             [pageable]="{
                               buttonCount: buttonCount,
                               info: info,
                               type: type,
                               pageSizes: pageSizes,
                               previousNext: previousNext,
                               position: position
                             }"
                             (pageChange)="pageChange($event)">
                               <ng-container  *ngFor="let ls of screenData">
                                 <kendo-grid-column *ngIf="ls.data_field == 'lang_desc' && ls.ctrl_id == 'LanguageGrid'"
                                 [style]="{ 'text-align': 'left' }"
                                 field="{{ls.data_field}}" title="{{ls.label_desc}}"
                                 width="80"> </kendo-grid-column>
                                 <kendo-grid-column *ngIf="ls.data_field == 'prod_desc' && ls.ctrl_id == 'LanguageGrid'"
                                 [style]="{ 'text-align': 'left' }"
                                 field="{{ls.data_field}}" title="{{ls.label_desc}}"
                                 width="170"></kendo-grid-column>
                                 </ng-container>
                                <!-- <kendo-grid-column [columnMenu]="false" [style]="{'border' : 'unset', 'background' : 'white'}" [class]="{'myClass': true}" field="a" title="" width="20" [headerStyle]="{'border' : 'unset', 'background' : 'white'}">
                                 <ng-template kendoGridCellTemplate let-dataItem *ngIf="mode != 'View'">
                                   <a (click)="setMode('Edit', dataItem)" style="background-color: white;">
                                     <img style="cursor:pointer;" src="assets/images/editicons.png"></a>&nbsp;&nbsp;&nbsp;
                                   <a (click)="delete('D', dataItem)" style="background-color: white;">
                                   <img style="cursor:pointer;" src="assets/images/del.png"></a>
                                 </ng-template>
                                 <ng-template kendoGridCellTemplate let-dataItem *ngIf="mode == 'View'">
                                   <a  style="background-color: white;" (click)="setMode('View', dataItem)">
                                     <img style="cursor:pointer;" src="assets/images/viewicons.png"></a>
                                 </ng-template>
                               </kendo-grid-column> -->
                             </kendo-grid>
                            </div>
                
                            <div id="price" class="container tab-pane" style="padding:0px;">
                              <kendo-grid [data]="priceGridData"
                              [sortable]="{
                               allowUnsort: allowUnsort,
                               mode: multiple ? 'multiple' : 'single'
                             }"
                             [filter]="state.filter"
                             filterable="menu"
                             (sortChange)="sortChange($event)"
                             (dataStateChange)="dataStateChange($event)"
                             [columnMenu]="{ filter: true }"
                             [skip]="skip"
                             [pageSize]="pageSize"
                             [pageable]="true"
                             [resizable]="true"
                             [pageable]="{
                               buttonCount: buttonCount,
                               info: info,
                               type: type,
                               pageSizes: pageSizes,
                               previousNext: previousNext,
                               position: position
                             }"
                             (pageChange)="pageChange($event)">
                               <ng-container  *ngFor="let ls of screenData">
                                 <kendo-grid-column *ngIf="ls.data_field == 'state_desc' && ls.ctrl_id == 'PriceGrid'"
                                 [style]="{ 'text-align': 'left' }"
                                 field="{{ls.data_field}}" title="{{ls.label_desc}}"
                                 width="80"> </kendo-grid-column>
                                 <kendo-grid-column *ngIf="ls.data_field == 'grade_desc' && ls.ctrl_id == 'PriceGrid'"
                                 [style]="{ 'text-align': 'left' }"
                                 field="{{ls.data_field}}" title="{{ls.label_desc}}"
                                 width="170"></kendo-grid-column>
                                 <kendo-grid-column filter="numeric" *ngIf="ls.data_field == 'msp_price' && ls.ctrl_id == 'PriceGrid'"
                                 [style]="{ 'text-align': 'right' }"
                                 field="{{ls.data_field}}" title="{{ls.label_desc}}"
                                 width="170"></kendo-grid-column>
                                 <kendo-grid-column filter="numeric" *ngIf="ls.data_field == 'procurement_price' && ls.ctrl_id == 'PriceGrid'"
                                 [style]="{ 'text-align': 'right' }"
                                 field="{{ls.data_field}}" title="{{ls.label_desc}}"
                                 width="170"></kendo-grid-column>
                                 <kendo-grid-column filter="date" *ngIf="ls.data_field == 'last_modified_date' && ls.ctrl_id == 'PriceGrid'"
                                 [style]="{ 'text-align': 'left' }"
                                 field="{{ls.data_field}}" title="{{ls.label_desc}}"
                                 width="170"></kendo-grid-column>
                                 </ng-container>
                             </kendo-grid>
                              <!-- <app-price [screenData]='screenData' [allGridData]="allGridData"></app-price> -->
                            </div>
                
                            <div id="quality" class="container tab-pane" style="padding:0px;">
                              <kendo-grid [data]="qualityGridData"
                              [sortable]="{
                               allowUnsort: allowUnsort,
                               mode: multiple ? 'multiple' : 'single'
                             }"
                             [filter]="state.filter"
                             filterable="menu"
                             (sortChange)="sortChange($event)"
                             (dataStateChange)="dataStateChange($event)"
                             [columnMenu]="{ filter: true }"
                             [skip]="skip"
                             [pageSize]="pageSize"
                             [pageable]="true"
                             [resizable]="true"
                             [pageable]="{
                               buttonCount: buttonCount,
                               info: info,
                               type: type,
                               pageSizes: pageSizes,
                               previousNext: previousNext,
                               position: position
                             }"
                             (pageChange)="pageChange($event)">
                               <ng-container *ngFor="let ls of screenData" >
                                 <kendo-grid-column *ngIf="ls.data_field == 'qltyparam_desc' && ls.ctrl_id == 'QualityGrid'"
                                 [style]="{ 'text-align': 'left' }"
                                 field="{{ls.data_field}}" title="{{ls.label_desc}}"
                                 width="80"> </kendo-grid-column>
                                 <kendo-grid-column filter="numeric" *ngIf="ls.data_field == 'range_from'  && ls.ctrl_id == 'QualityGrid'"
                                 [style]="{ 'text-align': 'right' }"
                                 field="{{ls.data_field}}" title="{{ls.label_desc}}"
                                 width="170"></kendo-grid-column>
                                 <kendo-grid-column filter="numeric" *ngIf="ls.data_field == 'range_to'  && ls.ctrl_id == 'QualityGrid'"
                                 [style]="{ 'text-align': 'right' }"
                                 field="{{ls.data_field}}" title="{{ls.label_desc}}"
                                 width="170"></kendo-grid-column>
                                 <kendo-grid-column *ngIf="ls.data_field == 'qltyuom_desc'  && ls.ctrl_id == 'QualityGrid'"
                                 [style]="{ 'text-align': 'left' }"
                                 field="{{ls.data_field}}" title="{{ls.label_desc}}"
                                 width="170"></kendo-grid-column>
                                 <kendo-grid-column filter="numeric" *ngIf="ls.data_field == 'threshold_value'  && ls.ctrl_id == 'QualityGrid'"
                                 [style]="{ 'text-align': 'right' }"
                                 field="{{ls.data_field}}" title="{{ls.label_desc}}"
                                 width="170"></kendo-grid-column>
                                 </ng-container>

                             </kendo-grid>
                            </div>
                          </div>
                        </div> 
                  </div>
                  </div>
            </form>
        </div>

   
